import { Component } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import { NavController, ToastController, LoadingController, AlertController, ViewController, Config  } from 'ionic-angular';
import { Project, Master, UserMyRadiant as User } from '../../../providers/';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';
import { LoginMyRadiant as LoginProvider, RepositoryMyRadiant, HelperMyRadiant, NewsMyRadiant} from '../../../providers/';
import { NewsPage } from "../index";
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { Clipboard } from '@ionic-native/clipboard';
import { t } from '@angular/core/src/render3';
import { Device } from '@ionic-native/device/ngx';

@Component({
  selector: 'page-detail',
  templateUrl: 'page.html'
})
export class DetailNewsPage {
  berita:any = '';
  loading : any;
  isLogin : any = 0;
  akses  = this.userApi.akses;
  data = {
    visitors:0,
    created_at : '',
    created_by : '',
  };
  count_loading = 2;

  constructor(
    public navCtrl        : NavController,
    public toastCtrl      : ToastController,
    public loadingCtrl    : LoadingController,
    public alertCtrl      : AlertController,
    public masterApi      : Master,
    public userApi        : User,
    public menuCtrl       : MenuController,
    public projectApi     : Project,
    public modalCtrl      : ModalController,
    public nav            : Nav,
    public navParams      : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public loginProvider  : LoginProvider,
    public viewCtrl       : ViewController,
    public config         : Config,
    public sanitizer      : DomSanitizer,
    public helper         : HelperMyRadiant,
    public apiNews        : NewsMyRadiant,
    public events         : Events,
    public clipboard      : Clipboard,
    public photoViewer    : PhotoViewer,
    public device        : Device
  ) {
    this.isLogin = (localStorage.is_login) ? true : false;
    this.berita = this.navParams.get('berita');
    this.berita.content = this.sanitizer.bypassSecurityTrustHtml(this.berita.content);
    this.config.set('backButtonText','Detail');
  }

  ionViewWillEnter(){
    document.getElementsByTagName('page-detail')[0].setAttribute("id",'detail-id-page')
    // console.log("asd");
    this.loading = this.helper.showLoading("Loading Data...");
    this.tambahVisitors();
  }

  ionViewDidEnter(){
    let page = document.getElementById("detail-id-page");
    const rateCmp = Array.from(page.getElementsByTagName('img'));
    let me = this;
    rateCmp.forEach((cmp) => {
      cmp.addEventListener("click",function(){                
        me.photoViewer.show(cmp.src);
      })
    });
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  editNews() {
    let me = this;
    me.loading = me.helper.showLoading("Please Wait...");
    me.apiNews.getNewsById(this.berita.id).subscribe((resp: any) => {
      if (resp.success) {        
        setTimeout(() => {
          me.helper.presentToast(resp.msg);          
          try {
            this.loading.dismiss();
          } catch (error) {

          }
        }, 1000);
        let data = resp.data;
        me.navCtrl.push(NewsPage,{state:'upd', data:data})
      } else {
        me.helper.presentToast(resp.msg);
      }
    }, (err) => {
      try {
        me.loading.dismiss();
      } catch (error) {

      }
    });
  }

  hapusNews() {
    let me = this,
      optionsSwal = {
        title: "Delete News?",      
      icon: "",
      dangerMode: false,
      btnCancel: "Cancel",
      btnConfirm: "Yes",
    }
    this.helper.presentSwalConfirmation(optionsSwal, () => {
      me.loading = me.helper.showLoading("Please Wait...");
      me.apiNews.deleteNews({ id: this.berita.id}).subscribe((resp: any) => {        
        if (resp.success) {
          me.events.publish('home:load_news');            
          setTimeout(() => {
            me.helper.presentToast(resp.msg);
            try {
              this.loading.dismiss();
            } catch (error) {

            }
            me.viewCtrl.dismiss();                      
          }, 1000);
          
        } else {
          me.helper.presentToast(resp.msg);
        }
      }, (err) => {
        try {
          me.loading.dismiss();
        } catch (error) {

        }
      });
    })
  }

  tambahVisitors(){
    let me = this;
    
    let params = {
      newsid : this.berita.id,
      token: "dashboard-frontend",
      tipe : this.userApi.is_login == 1 ? 'dashboard' : 'intranews' ,
      // deviceid : this.device.uuid,
    };
    if (params.tipe == 'dashboard') {
      params['user_id'] = this.userApi.data.user_id;
    };
    this.repositoryProvider.addVisitors(params).subscribe((resp:any) => {
      if (resp.success) {
        me.visitors();
      }else{
        // try {
        //   this.loading.dismiss();
        // } catch (error) {}
      }
    },(err) => {
      this.presentToast('Error');
    });
  }

  visitors(){
    let me = this;
    
    let params = {
      token : "dashboard-frontend",
      board : this.berita.id,
      type : this.userApi.is_login == 1 ? 'dashboard' : 'intranews' ,
    }
    this.repositoryProvider.getVisitors(params).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {}
      if (resp.success) {
        let data = resp.data;
        me.data.visitors = data.count_visitor;
        me.data.created_by = data.created_name;
        me.data.created_at = data.date_news_created;
      }
    },(err) => {
      this.presentToast('Error');
    });
  }

  copyUrl(){
    let dashapp = '';
    if (this.berita.category_url != 'public') {
      dashapp = 'dashapp/';
    }
    // console.log('http://intranews.appsradiant.com/#/post/'+this.berita.id+'/'+this.berita.category_url+'/'+this.berita.seo_title);
    try {
      this.clipboard.copy('http://intranews.appsradiant.com/'+dashapp+'#/post/'+this.berita.id+'/'+this.berita.category_url+'/'+this.berita.seo_title);
      this.presentToast("Copy Link News");
    } catch (error) {
      
    }
  }
 
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/detailnews/page.ts